<template>
  <div
    class="align-center d-flex flex-column"
    style="margin-top: 200px;"
  >
    <v-icon
      class="mb-10"
      color="red lighten-2"
      x-large
    >
      mdi-heart-broken-outline
    </v-icon>

    <p class="font-weight-bold primary--text text-h1">
      Uh Oh!
    </p>

    <p class="text-h6">
      The page you are looking for doesn't exist or has expired.
    </p>
  </div>
</template>

<script>
export default {
  name: 'PageNotFoundView',
}
</script>
